<template>
  <div class="p-config-management-form-list__row" @click.prevent="click">
    <div class="p-config-management-form-list__col--check">
      <Checkbox
        :id="item.id"
        name="site[]"
        :value="item.id"
        :checked="checked"
        ref="input"
        @change="change"
      />
    </div>
    <div class="p-config-management-form-list__col">{{ item.name }}</div>
    <div class="p-config-management-form-list__col">{{ item.siteUrl }}</div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: [Array, String],
      required: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    Checkbox
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    },
    click() {
      this.$refs.input.change();
    }
  }
};
</script>
